import "./Footer.module.scss";

export const Footer = () => {
  return (
    <div className="footer">
      <div className="info-text">
        &copy; {new Date().getFullYear()}
        <br></br>
        <a className="linkFooter" href="mailto:caninogroupitalia@gmail.com">caninogroupitalia@gmail.com</a>
      </div>
    </div>
  );
};